export const SHOP_TYPE = Object.freeze({
  RESTAURANT: 1,
  GROCERY: 2,
  SERVICE: 3,
});

export const SHOP_TYPE_LABELS = Object.freeze({
  [SHOP_TYPE.RESTAURANT]: 'Restaurant',
  [SHOP_TYPE.GROCERY]: 'Grocery',
  [SHOP_TYPE.SERVICE]: 'Service',
});

export const isServiceShop = shopTypeId => shopTypeId === SHOP_TYPE.SERVICE;

// Terminology helpers
export const getCatalogueLabel = shopTypeId => isServiceShop(shopTypeId) ? 'Services' : 'Menu';
export const getCategoryLabel = shopTypeId => isServiceShop(shopTypeId) ? 'Section' : 'Category';
export const getItemLabel = shopTypeId => isServiceShop(shopTypeId) ? 'Service' : 'Item';
export const getOrderLabel = shopTypeId => isServiceShop(shopTypeId) ? 'Booking' : 'Order';
export const getOrdersLabel = shopTypeId => isServiceShop(shopTypeId) ? 'Bookings' : 'Orders';
export const getPartnerLabel = shopTypeId => isServiceShop(shopTypeId) ? 'Partner' : 'Driver';
export const getPartnersLabel = shopTypeId => isServiceShop(shopTypeId) ? 'Partners' : 'Drivers';
export const getPartnersNavLabel = shopTypeId => isServiceShop(shopTypeId) ? 'Partners' : 'Delivery Partners';
